module.exports = __webpack_public_path__ + "img/major1.f783b291.png";